<ng-container
  *ngIf="{
    categories: categories$ | async,
    products: products$ | async
  } as data"
>
  <div class="plp-container">
    <div class="selector-container">
      <ng-container *ngIf="data.categories; else spinner">
        <app-product-filter
          [categories]="data.categories"
          (selectedCategory)="changeCategory($event)"
          (sortHigherToLower)="sortHigher($event)"
          (sortLowerToHigher)="sortLower($event)"
        ></app-product-filter>
      </ng-container>
    </div>
    <div class="products-grid-container">
      <ng-container *ngIf="data.products; else spinner">
        <app-product-grid [products]="data.products"></app-product-grid>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #spinner>
  <app-spinner></app-spinner>
</ng-template>
